import React from 'react';
import { useParams } from 'react-router-dom';
import LibModal from '../../../features/LibModal/LibModal';
import NotFound from '../../../features/NotFound/NotFoundPage';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { GetDynamicValue } from '../../../utils/URL';
import AgencyInfoProvider, { useAgencyInfo } from '../AgencyInfoProvider';
import ModalAgencyChangeCurrency from '../List/Modals/ModalAgencyChangeCurrency';
import ModalAgencyInfoUpdate from '../List/Modals/ModalAgencyInfoUpdate';
import ModalCreateAgencyCustomer from '../List/Modals/ModalCreateAgencyCustomer';
import AddressContent from './Components/Address/AddressContent';
import AgencyInfoPageHeader from './Components/AgencyInfoPageHeader';
import AgencyStatusMessageShow from './Components/AgencyStatusMessageShow';
import AgencyTabView from './Components/AgencyTabView';
import TabAgencyCustomerPage from './Components/TabTablePages/Customers/TabAgencyCustomerPage';
import TabAgencyInvoicesPage from './Components/TabTablePages/Invoices/TabAgencyInvoicesPage';
import TabAgencyPaymentsPage from './Components/TabTablePages/Payments/TabAgencyPaymentsPage';
import TabAgencyServicesPage from './Components/TabTablePages/Services/TabAgencyServicesPage';
import TabAgencySubscriptionsPage from './Components/TabTablePages/Subscriptions/TabAgencySubscriptionsPage';
import TabAgencySupportTicketsPage from './Components/TabTablePages/SupportTickets/TabAgencySupportTicketsPage';

// eslint-disable-next-line no-unused-vars
function TabComponentRender({ data }) {
    const tabName = GetDynamicValue('tab') || 'customers';
    // console.log('TabComponentRender -> tabName', tabName);
    switch (tabName) {
        case 'customers':
            return <TabAgencyCustomerPage data={data} />;
        case 'subscriptions':
            return <TabAgencySubscriptionsPage data={data} />;
        case 'invoices':
            return <TabAgencyInvoicesPage data={data} />;
        case 'payments':
            return <TabAgencyPaymentsPage data={data} />;
        case 'support-ticket':
            return <TabAgencySupportTicketsPage data={data} />;
        case 'services':
            return <TabAgencyServicesPage data={data} />;
        default:
            return null;
    }
}

function PageCont() {
    const { agencyInfoData, handleReload } = useAgencyInfo();
    const { modalType, closeModal } = useTemplate();

    // If no data found
    if (agencyInfoData && Object.keys(agencyInfoData).length === 0) {
        return (
            <div className="inner_page_cont">
                <NotFound
                    title="No Agency Found!"
                    btnTitle="Back to list"
                    path="/agency"
                    className="h-full"
                />
            </div>
        );
    }

    return (
        <div className="agency_details_page inner_page_cont overflow-x-hidden">
            {/* Header Card */}
            <AgencyInfoPageHeader />
            {/* Status Message Show */}
            <AgencyStatusMessageShow data={agencyInfoData} />
            {/* Address List (administrative, billing, technical) */}
            <AddressContent addressData={agencyInfoData?.addresses} />
            {/* Address Modal */}
            <div className="agency_details_body pb-40">
                <AgencyTabView data={agencyInfoData} />
                <TabComponentRender data={agencyInfoData} />
            </div>

            {modalType === 'create-agency-customer-modal' && (
                <LibModal
                    title="Create New Agency Customer"
                    setOpen={closeModal}
                    className="md:!w-[550px]"
                >
                    <ModalCreateAgencyCustomer onReload={handleReload} />
                </LibModal>
            )}
            {modalType === 'UPDATE_AGENCY_INFO_MODAL' && (
                <LibModal title="Update Agency Info" setOpen={closeModal} className="md:!w-[450px]">
                    <ModalAgencyInfoUpdate onReload={handleReload} />
                </LibModal>
            )}

            {modalType === 'CHANGE_AGENCY_CURRENCY_MODAL' && (
                <LibModal
                    title="Change Agency Currency"
                    setOpen={closeModal}
                    className="md:!w-[450px]"
                >
                    <ModalAgencyChangeCurrency onReload={handleReload} />
                </LibModal>
            )}
        </div>
    );
}

function AgencyInfoPage() {
    const { agencyId } = useParams();
    return (
        <AgencyInfoProvider agencyId={agencyId}>
            <PageCont />
        </AgencyInfoProvider>
    );
}

export default AgencyInfoPage;
